import {noticeSeverities, NoticeSeverity} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<NoticeSeverity>;

export const NoticeSeveritySelect = (props: Props) => {
  const {options = noticeSeverities, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
